/* eslint-disable max-len */
import { type ApplicationListEndpointContextDataFragment } from '../../../../api/fragments/ApplicationListEndpointContextData';
import ApplicationListPageInner from './ApplicationListPageInner';

export type ApplicationListPageProps = {
    endpoint: ApplicationListEndpointContextDataFragment;
};

const ApplicationListPage = ({ endpoint }: ApplicationListPageProps) => {
    const namespace = 'applicationList';

    return <ApplicationListPageInner endpoint={endpoint} namespace={namespace} />;
};

export default ApplicationListPage;
